<style scoped>
.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.form-row > div {
    flex: 1;
}

.info-box {
    background-color: rgb(250, 251, 252);
    border-left: 4px solid #3498db;
    padding: 15px 20px;
    margin: 20px 0;
    border-radius: 4px;
}

.info-box h4 {
    margin: 0 0 10px 0;
    color: #2c3e50;
    font-size: 14px;
}

.info-box p {
    margin: 5px 0;
    color: #7f8c8d;
    font-size: 13px;
}

.error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 5px;
}
</style>

<template>
    <Modal id="modal-multi-affair-supplier-invoice">
        <template v-slot:modalIcon>
            <font-awesome-icon :icon="['fas', 'file-invoice-dollar']" />
        </template>
        <template v-slot:modalTitle>
            <div>CRÉER UNE FACTURE DEPUIS UNE RÉCEPTION MULTI-AFFAIRES</div>
        </template>
        <template v-slot:modalContent>
            <form @submit.prevent="handleSubmit">
                <div class="info-box">
                    <h4>ℹ️ Information</h4>
                    <p>Cette fonctionnalité permet de créer une facture fournisseur à partir d'une réception multi-affaires existante.</p>
                </div>

                <div class="form-row">
                    <BaseInput
                        v-model="invoice.receptionId"
                        label="ID de la réception multi-affaires"
                        type="number"
                        :required="true"
                        :error="errors.receptionId"
                        @onChange="clearError('receptionId')"
                        placeholder="Entrer l'ID de la réception"
                    />
                </div>

                <div class="form-row">
                    <BaseInput
                        v-model="invoice.invoiceNumber"
                        label="N° de facture fournisseur"
                        type="text"
                        :required="true"
                        :error="errors.invoiceNumber"
                        @onChange="clearError('invoiceNumber')"
                        placeholder="FAC-2026-001"
                    />
                </div>

                <div class="form-row">
                    <BaseDatepicker
                        v-model="invoice.invoiceDate"
                        label="Date de facture"
                        :displayTime="false"
                        name="invoiceDate"
                        :required="true"
                        :error="errors.invoiceDate"
                        @onChange="clearError('invoiceDate')"
                    />
                    <BaseDatepicker
                        v-model="invoice.dueDate"
                        label="Date d'échéance"
                        :displayTime="false"
                        name="dueDate"
                        :required="true"
                        :error="errors.dueDate"
                        @onChange="clearError('dueDate')"
                    />
                </div>
            </form>
        </template>
        <template v-slot:modalActions>
            <BaseButton buttonText="Annuler" @click="handleCancel" color="transparent" />
            <BaseButton 
                buttonText="Créer la facture" 
                @click="handleSubmit"
            />
        </template>
    </Modal>
</template>

<script>
import Modal from './Modal.vue';
import BaseButton from '../Base/BaseButton.vue';
import BaseInput from '../Base/BaseInput.vue';
import BaseDatepicker from '../Base/BaseDatepicker.vue';
import axios from '../../config/axios';
import { format } from 'date-fns';

export default {
    name: 'MultiAffairSupplierInvoiceModal',
    components: {
        Modal,
        BaseButton,
        BaseInput,
        BaseDatepicker
    },
    props: {
        receptionId: {
            type: Number,
            default: null
        }
    },
    emits: ['close', 'created'],
    data() {
        return {
            invoice: {
                receptionId: '',
                invoiceNumber: '',
                invoiceDate: new Date(),
                dueDate: new Date()
            },
            errors: {}
        };
    },
    mounted() {
        // Si un receptionId est passé en prop, pré-remplir le champ
        if (this.receptionId) {
            this.invoice.receptionId = this.receptionId.toString();
        }
    },
    methods: {
        clearError(field) {
            if (this.errors[field]) {
                delete this.errors[field];
            }
        },
        validate() {
            this.errors = {};

            if (!this.invoice.receptionId || this.invoice.receptionId <= 0) {
                this.errors.receptionId = 'L\'ID de la réception est obligatoire';
            }
            if (!this.invoice.invoiceNumber || this.invoice.invoiceNumber.trim() === '') {
                this.errors.invoiceNumber = 'Le numéro de facture est obligatoire';
            }
            if (!this.invoice.invoiceDate) {
                this.errors.invoiceDate = 'La date de facture est obligatoire';
            }
            if (!this.invoice.dueDate) {
                this.errors.dueDate = 'La date d\'échéance est obligatoire';
            }

            return Object.keys(this.errors).length === 0;
        },
        async handleSubmit() {
            if (!this.validate()) {
                return;
            }

            try {
                const payload = {
                    receptionId: parseInt(this.invoice.receptionId),
                    invoiceNumber: this.invoice.invoiceNumber.trim(),
                    invoiceDate: this.invoice.invoiceDate instanceof Date 
                        ? format(this.invoice.invoiceDate, 'yyyy-MM-dd')
                        : this.invoice.invoiceDate,
                    dueDate: this.invoice.dueDate instanceof Date 
                        ? format(this.invoice.dueDate, 'yyyy-MM-dd')
                        : this.invoice.dueDate
                };

                await axios.post('supplierInvoice/createFromMultiAffairReception', payload, {
                    toastSuccessMessage: 'Facture fournisseur créée avec succès',
                    toastError: true,
                    showPreloader: true
                });
                
                this.$emit('created');
                this.handleCancel();
            } catch (error) {
                console.error('Erreur lors de la création de la facture:', error);
            }
        },
        handleCancel() {
            this.invoice = {
                receptionId: '',
                invoiceNumber: '',
                invoiceDate: new Date(),
                dueDate: new Date()
            };
            this.errors = {};
            this.$emit('close');
        }
    }
};
</script>
